import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

import { NgxFilesizeModule } from 'ngx-filesize';
import { AlertModule, ComponentsModule } from '@ed---interne/ng-uui-components';

import { SidenavComponent } from '../../shared/components/sidenav/sidenav.component';
import { MainComponent } from './main.component';
import { HomeComponent } from './home/home.component';

import { AccountComponent } from './settings/account/account.component';
import { AccountPasswordEditComponent } from './settings/edit-password/account-password-edit.component';

import { UsersComponent } from '../admin/users/users.component';

import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { EdTableModule } from '../../shared/components/ed-table/ed-table.module';

import { InfiniteScrollDirective } from '../../shared/directives/infinite-scroll.directive';
import { DragAndDropDirective } from '../../shared/directives/drag-and-drop.directive';

import { OrganizationComponent } from '../admin/organization/organization.component';

import { CracComponent } from './crac/crac.component';
import { GeneralCracComponent } from './crac/components/generalcrac/generalcrac.component';

import { GenericComponent } from './concessioncontrol/components/generic/generic.component';
import { WelcomeComponent } from './concessioncontrol/components/welcome/welcome.component';
import { GeneralInfoComponent } from './concessioncontrol/components/general-info/general-info.component';
import { SourceStationsComponent } from './concessioncontrol/components/sourcestations/sourcestations.component';

import { MvNetworksComponent } from './concessioncontrol/components/mv-networks/mv-networks.component';
import { MvNetworksUndergroundingComponent } from './concessioncontrol/components/mv-networks-undergrounding/mv-networks-undergrounding.component';
import { MvNetworksAgesComponent } from './concessioncontrol/components/mv-networks-ages/mv-networks-ages.component';
import { LvNetworksComponent } from './concessioncontrol/components/lv-networks/lv-networks.component';
import { LvNetworksUndergroundingComponent } from './concessioncontrol/components/lv-networks-undergrounding/lv-networks-undergrounding.component';
import { LvNetworksAgesComponent } from './concessioncontrol/components/lv-networks-ages/lv-networks-ages.component';
import { TransformerOthersComponent } from './concessioncontrol/components/transformer-others/transformer-others.component';
import { MetersComponent } from './concessioncontrol/components/transformer-meters/meters.component';
import { TransformerSubstationsComponent } from './concessioncontrol/components/transformer-substations/transformer-substations.component';
import { VoltageQualityComponent } from './concessioncontrol/components/voltage-quality/voltage-quality.component';

import { SupplyContinuityComponent } from './concessioncontrol/components/supply-continuity/supply-continuity.component';
import { SupplyContinuityBCriterionComponent } from './concessioncontrol/components/supply-continuity-b-criterion/supply-continuity-b-criterion.component';
import { SupplyContinuityOutagesComponent } from './concessioncontrol/components/supply-continuity-outages/supply-continuity-outages.component';
import { SupplyContinuityIncidentologyComponent } from './concessioncontrol/components/supply-continuity-incidentology/supply-continuity-incidentology.component';
import { ExpensesInvestmentsComponent } from './concessioncontrol/components/expenses-investments/expenses-investments.component';
import { AccountingIndicatorsComponent } from './concessioncontrol/components/accounting-indicators/accounting-indicators.component';
import { OperatingAccountComponent } from './concessioncontrol/components/operating-account/operating-account.component';

import { ExpensesMaintenanceComponent } from './concessioncontrol/components/expenses-maintenance/expenses-maintenance.component';

import { EnedisUsersComponent } from './concessioncontrol/components/enedis-users/enedis-users.component';
import { EnedisProducersComponent } from './concessioncontrol/components/enedis-producers/enedis-producers.component';
import { EnedisConnectionsComponent } from './concessioncontrol/components/enedis-connections/enedis-connections.component';
import { EnedisQualityComponent } from './concessioncontrol/components/enedis-quality/enedis-quality.component';
import { EnedisClaimsComponent } from './concessioncontrol/components/enedis-claims/enedis-claims.component';

import { EdfTrvComponent } from './concessioncontrol/components/edf-trv/edf-trv.component';
import { EdfQualityComponent } from './concessioncontrol/components/edf-quality/edf-quality.component';
import { EdfClaimsComponent } from './concessioncontrol/components/edf-claims/edf-claims.component';
import { EdfPovertyComponent } from './concessioncontrol/components/edf-poverty/edf-poverty.component';
import { AccountingRightsComponent } from './concessioncontrol/components/accounting-rights/accounting-rights.component';
import { CracmapComponent } from './cracmap/cracmap.component';

@NgModule({
    declarations: [
        MainComponent,
        SidenavComponent,
        HomeComponent,
        UsersComponent,
        AccountComponent,
        AccountPasswordEditComponent,
        OrganizationComponent,
        CracComponent,
        GeneralCracComponent,
        GenericComponent,
        WelcomeComponent,
        GeneralInfoComponent,
        SourceStationsComponent,
        MvNetworksComponent,
        MvNetworksUndergroundingComponent,
        MvNetworksAgesComponent,
        LvNetworksComponent,
        LvNetworksUndergroundingComponent,
        LvNetworksAgesComponent,
        TransformerOthersComponent,
        MetersComponent,
        TransformerSubstationsComponent,
        VoltageQualityComponent,
        SupplyContinuityComponent,
        SupplyContinuityBCriterionComponent,
        SupplyContinuityOutagesComponent,
        SupplyContinuityIncidentologyComponent,
        ExpensesInvestmentsComponent,
        AccountingIndicatorsComponent,
        OperatingAccountComponent,
        EnedisUsersComponent,
        EnedisProducersComponent,
        EnedisConnectionsComponent,
        EnedisQualityComponent,
        EnedisClaimsComponent,
        EdfTrvComponent,
        EdfQualityComponent,
        EdfClaimsComponent,
        EdfPovertyComponent,
        ExpensesMaintenanceComponent,
        AccountingRightsComponent,

        CracmapComponent,
    ],
    imports: [
        CommonModule,
        NgbModule,
        RouterModule,
        FormsModule,
        SharedModule,
        ComponentsModule,
        CoreModule,
        EdTableModule,
        InfiniteScrollDirective,
        DragAndDropDirective,
        ReactiveFormsModule,
        MatMenuModule,
        MatExpansionModule,
        MatSidenavModule,
        MatTableModule,
        MatSortModule,
        AlertModule,
        NgxFilesizeModule,
    ],
})
export class MainModule {}
